module.exports = __webpack_public_path__ + "section/burger/img/ico-login.svg?hash=2ef439a5d8f980124a2d0fd55b8648e6"


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/asset-loader!./LeLab.LogAlto.Web/src/modules/section/burger/img/ico-login.svg
 ** module id = 19
 ** module chunks = 0 1
 **/